var _assertThisInitialized = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var _regeneratorRuntime = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/my/my/sites/node_modules/@babel/runtime/helpers/createClass");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else {
    var a = factory();

    for (var i in a) {
      (typeof exports === 'object' ? exports : root)[i] = a[i];
    }
  }
})(self, function () {
  return (
    /******/
    function () {
      // webpackBootstrap

      /******/
      "use strict";
      /******/

      var __webpack_modules__ = [
        /* 0 */
      ,
      /* 1 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          Authentication: function Authentication() {
            return (
              /* binding */
              _Authentication
            );
          }
          /* harmony export */

        });
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

        var _Authentication = /*#__PURE__*/function () {
          function _Authentication() {
            _classCallCheck(this, _Authentication);
          }

          _createClass(_Authentication, [{
            key: "getLoginData",
            value: function () {
              var _getLoginData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(oneAuthUrl, payload, realm) {
                var resData, regRes, newRes;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        resData = {
                          error: false,
                          message: ""
                        };

                        if (!(oneAuthUrl && realm)) {
                          _context.next = 17;
                          break;
                        }

                        _context.next = 4;
                        return fetch("".concat(oneAuthUrl, "/realms/").concat(realm, "/protocol/openid-connect/token"), {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/x-www-form-urlencoded"
                          },
                          body: payload.toString()
                        }).then(function (res) {
                          return res;
                        }).catch(function (e) {// console.log(e);
                        });

                      case 4:
                        regRes = _context.sent;

                        if (!(regRes && (regRes === null || regRes === void 0 ? void 0 : regRes.status) !== 200)) {
                          _context.next = 13;
                          break;
                        }

                        _context.next = 8;
                        return regRes.json();

                      case 8:
                        newRes = _context.sent;
                        resData.error = true;
                        resData.message = (newRes === null || newRes === void 0 ? void 0 : newRes.error_description) || "Auth Error";
                        _context.next = 17;
                        break;

                      case 13:
                        resData.error = false;
                        _context.next = 16;
                        return regRes.json();

                      case 16:
                        resData.data = _context.sent;

                      case 17:
                        return _context.abrupt("return", resData);

                      case 18:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              function getLoginData(_x, _x2, _x3) {
                return _getLoginData.apply(this, arguments);
              }

              return getLoginData;
            }()
          }, {
            key: "userLogout",
            value: function () {
              var _userLogout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(config) {
                var subPath,
                    redirect_uri,
                    authInfo,
                    resData,
                    formData,
                    _args2 = arguments;
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        subPath = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "";
                        redirect_uri = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.getRedirectUrl)(subPath);
                        authInfo = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.getFromLocalStorage)("hfnAuthInfo");
                        resData = {
                          error: false,
                          message: ""
                        };

                        if (!(config !== null && config !== void 0 && config.authUrl && config !== null && config !== void 0 && config.realm && config !== null && config !== void 0 && config.client_id && authInfo !== null && authInfo !== void 0 && authInfo.id_token && redirect_uri)) {
                          _context2.next = 17;
                          break;
                        }

                        formData = new URLSearchParams();
                        formData.append("client_id", config === null || config === void 0 ? void 0 : config.client_id);
                        formData.append("id_token_hint", authInfo === null || authInfo === void 0 ? void 0 : authInfo.id_token);
                        formData.append("post_logout_redirect_uri", redirect_uri);
                        _context2.prev = 9;
                        _context2.next = 12;
                        return fetch("".concat(config === null || config === void 0 ? void 0 : config.authUrl, "/realms/").concat(config === null || config === void 0 ? void 0 : config.realm, "/protocol/openid-connect/logout"), {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/x-www-form-urlencoded"
                          },
                          redirect: "manual",
                          body: formData.toString()
                        }).then(function () {
                          (0, _utils__WEBPACK_IMPORTED_MODULE_0__.clearLsAuthInfo)();
                        });

                      case 12:
                        _context2.next = 17;
                        break;

                      case 14:
                        _context2.prev = 14;
                        _context2.t0 = _context2["catch"](9);
                        console.log("Unable to log out at this time. Please try again later.");

                      case 17:
                        return _context2.abrupt("return", resData);

                      case 18:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[9, 14]]);
              }));

              function userLogout(_x4) {
                return _userLogout.apply(this, arguments);
              }

              return userLogout;
            }()
          }, {
            key: "getActiveToken",
            value: function () {
              var _getActiveToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(config, force) {
                var resData, authInfo, activeToken, _activeToken, tokenExpired, formData;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        resData = {
                          error: false,
                          message: ""
                        };
                        authInfo = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.getFromLocalStorage)("hfnAuthInfo");
                        activeToken = authInfo;

                        if (!(authInfo !== null && authInfo !== void 0 && authInfo.refresh_token)) {
                          _context3.next = 20;
                          break;
                        }

                        tokenExpired = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.checkKeycloakTokenIsExpired)(authInfo === null || authInfo === void 0 ? void 0 : authInfo.access_token);

                        if (!(force || tokenExpired)) {
                          _context3.next = 18;
                          break;
                        }

                        _context3.prev = 6;
                        formData = new URLSearchParams();
                        formData.append("client_id", config === null || config === void 0 ? void 0 : config.client_id);
                        formData.append("refresh_token", authInfo === null || authInfo === void 0 ? void 0 : authInfo.refresh_token);
                        formData.append("grant_type", "refresh_token");
                        _context3.next = 13;
                        return fetch("".concat(config === null || config === void 0 ? void 0 : config.authUrl, "/realms/").concat(config === null || config === void 0 ? void 0 : config.realm, "/protocol/openid-connect/token"), {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/x-www-form-urlencoded"
                          },
                          body: formData.toString()
                        }).then(function (res) {
                          return res.json();
                        }).then(function (data) {
                          if (tokenExpired) {
                            localStorage.setItem("loginDateTime", new Date());
                          }

                          return data;
                        });

                      case 13:
                        activeToken = _context3.sent;
                        _context3.next = 18;
                        break;

                      case 16:
                        _context3.prev = 16;
                        _context3.t0 = _context3["catch"](6);

                      case 18:
                        resData.data = activeToken;

                        if ((_activeToken = activeToken) !== null && _activeToken !== void 0 && _activeToken.access_token) {
                          (0, _utils__WEBPACK_IMPORTED_MODULE_0__.storeInLocalStorage)("hfnAuthInfo", activeToken);
                        }

                      case 20:
                        return _context3.abrupt("return", resData);

                      case 21:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[6, 16]]);
              }));

              function getActiveToken(_x5, _x6) {
                return _getActiveToken.apply(this, arguments);
              }

              return getActiveToken;
            }() //it's a duplicate method and will be removed in future release

          }, {
            key: "getMySRCMProfie",
            value: function () {
              var _getMySRCMProfie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(config) {
                var resData, authInfo, _data$results, srcmMeUrl, xClientId, response, data;

                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        resData = {
                          error: false,
                          message: ""
                        };
                        authInfo = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.getFromLocalStorage)("hfnAuthInfo");
                        _context4.prev = 2;
                        srcmMeUrl = config === null || config === void 0 ? void 0 : config.srcmMeUrl;
                        xClientId = config === null || config === void 0 ? void 0 : config.xClientId;
                        _context4.next = 7;
                        return fetch("".concat(srcmMeUrl), {
                          method: "GET",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(authInfo === null || authInfo === void 0 ? void 0 : authInfo.access_token),
                            "x-client-id": "".concat(xClientId)
                          }
                        });

                      case 7:
                        response = _context4.sent;
                        _context4.next = 10;
                        return response.json();

                      case 10:
                        data = _context4.sent;
                        resData.data = ((_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results[0]) || null;
                        _context4.next = 16;
                        break;

                      case 14:
                        _context4.prev = 14;
                        _context4.t0 = _context4["catch"](2);

                      case 16:
                        return _context4.abrupt("return", resData);

                      case 17:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[2, 14]]);
              }));

              function getMySRCMProfie(_x7) {
                return _getMySRCMProfie.apply(this, arguments);
              }

              return getMySRCMProfie;
            }()
          }, {
            key: "getMeSRCMProfie",
            value: function () {
              var _getMeSRCMProfie = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(config) {
                var resData, authInfo, _data$results2, srcmBaseURL, xClientId, access_token, response, data;

                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        resData = {
                          error: false,
                          message: ""
                        };
                        authInfo = (0, _utils__WEBPACK_IMPORTED_MODULE_0__.getFromLocalStorage)("hfnAuthInfo");
                        _context5.prev = 2;
                        srcmBaseURL = config === null || config === void 0 ? void 0 : config.srcmBaseURL;
                        xClientId = config === null || config === void 0 ? void 0 : config.xClientId;
                        access_token = (config === null || config === void 0 ? void 0 : config.access_token) || (authInfo === null || authInfo === void 0 ? void 0 : authInfo.access_token);
                        _context5.next = 8;
                        return fetch("".concat(srcmBaseURL, "api/v2/me/"), {
                          method: "GET",
                          headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer ".concat(access_token),
                            "x-client-id": xClientId || ""
                          }
                        });

                      case 8:
                        response = _context5.sent;
                        _context5.next = 11;
                        return response.json();

                      case 11:
                        data = _context5.sent;
                        resData.data = ((_data$results2 = data.results) === null || _data$results2 === void 0 ? void 0 : _data$results2[0]) || null;
                        _context5.next = 19;
                        break;

                      case 15:
                        _context5.prev = 15;
                        _context5.t0 = _context5["catch"](2);
                        resData.error = true;
                        resData.message = _context5.t0.message;

                      case 19:
                        return _context5.abrupt("return", resData);

                      case 20:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, null, [[2, 15]]);
              }));

              function getMeSRCMProfie(_x8) {
                return _getMeSRCMProfie.apply(this, arguments);
              }

              return getMeSRCMProfie;
            }()
          }]);

          return _Authentication;
        }();
        /***/

      },
      /* 2 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          HideBlock: function HideBlock() {
            return (
              /* binding */
              _HideBlock
            );
          },

          /* harmony export */
          base64Decode: function base64Decode() {
            return (
              /* binding */
              _base64Decode
            );
          },

          /* harmony export */
          base64Encode: function base64Encode() {
            return (
              /* binding */
              _base64Encode
            );
          },

          /* harmony export */
          base64urlencode: function base64urlencode() {
            return (
              /* binding */
              _base64urlencode
            );
          },

          /* harmony export */
          checkKeycloakTokenIsExpired: function checkKeycloakTokenIsExpired() {
            return (
              /* binding */
              _checkKeycloakTokenIsExpired
            );
          },

          /* harmony export */
          clearLsAuthInfo: function clearLsAuthInfo() {
            return (
              /* binding */
              _clearLsAuthInfo
            );
          },

          /* harmony export */
          displayErrorBlock: function displayErrorBlock() {
            return (
              /* binding */
              _displayErrorBlock
            );
          },

          /* harmony export */
          generateCodeChallenge: function generateCodeChallenge() {
            return (
              /* binding */
              _generateCodeChallenge
            );
          },

          /* harmony export */
          getAuthCode: function getAuthCode() {
            return (
              /* binding */
              _getAuthCode
            );
          },

          /* harmony export */
          getDomElementByClass: function getDomElementByClass() {
            return (
              /* binding */
              _getDomElementByClass
            );
          },

          /* harmony export */
          getDomElementById: function getDomElementById() {
            return (
              /* binding */
              _getDomElementById
            );
          },

          /* harmony export */
          getFromLocalStorage: function getFromLocalStorage() {
            return (
              /* binding */
              _getFromLocalStorage
            );
          },

          /* harmony export */
          getRedirectUrl: function getRedirectUrl() {
            return (
              /* binding */
              _getRedirectUrl
            );
          },

          /* harmony export */
          isUserAuthenticated: function isUserAuthenticated() {
            return (
              /* binding */
              _isUserAuthenticated
            );
          },

          /* harmony export */
          sha256: function sha256() {
            return (
              /* binding */
              _sha
            );
          },

          /* harmony export */
          showErrorMsg: function showErrorMsg() {
            return (
              /* binding */
              _showErrorMsg
            );
          },

          /* harmony export */
          storeInLocalStorage: function storeInLocalStorage() {
            return (
              /* binding */
              _storeInLocalStorage
            );
          }
          /* harmony export */

        });
        /* harmony import */


        var jwt_decode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);

        function _showErrorMsg(selector, text) {
          var errorBlock = document.querySelector(selector);
          errorBlock.innerHTML = text;
          errorBlock.setAttribute("style", "color:#970808;text-align:center;");
          return true;
        }

        function _HideBlock(selector) {
          var blocks = document.querySelectorAll(selector);
          blocks.forEach(function (block) {
            block.setAttribute("style", "display:none;");
          });
          return true;
        }

        function _displayErrorBlock() {
          var blocks = document.querySelectorAll(".error-block");
          blocks.forEach(function (block) {
            block.setAttribute("style", "display:inline-block;");
          });
          return true;
        }

        function _getDomElementById(id) {
          return document.getElementById(id);
        }

        function _getDomElementByClass(cls) {
          return document.getElementsByClassName(cls);
        }

        var _base64Encode = function _base64Encode(str) {
          return btoa(unescape(encodeURIComponent(str)));
        };

        var _base64Decode = function _base64Decode(str) {
          var decodedJson = atob(str);
          return JSON.parse(decodedJson);
        };

        var _storeInLocalStorage = function _storeInLocalStorage(key, value) {
          var encodedValue = _base64Encode(JSON.stringify(value));

          localStorage.setItem(key, encodedValue);
        };

        var _getFromLocalStorage = function _getFromLocalStorage(key) {
          var encodedValue = localStorage.getItem(key);

          if (encodedValue) {
            return _base64Decode(encodedValue);
          }

          return null;
        };

        var _clearLsAuthInfo = function _clearLsAuthInfo() {
          localStorage.removeItem("loginDateTime");
          localStorage.removeItem("hfnAuthInfo");
        };

        function dec2hex(dec) {
          return ("0" + dec.toString(16)).substr(-2);
        }

        function generateCodeVerifier() {
          var array = new Uint32Array(56 / 2);
          window.crypto.getRandomValues(array);
          return Array.from(array, dec2hex).join("");
        }

        function _sha(plain) {
          var encoder = new TextEncoder();
          var data = encoder.encode(plain);
          return window.crypto.subtle.digest("SHA-256", data);
        }

        function _base64urlencode(a) {
          var str = "";
          var bytes = new Uint8Array(a);
          var len = bytes.byteLength;

          for (var i = 0; i < len; i++) {
            str += String.fromCharCode(bytes[i]);
          }

          return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        }

        function generateCodeChallengeFromVerifier(_x9) {
          return _generateCodeChallengeFromVerifier.apply(this, arguments);
        }

        function _generateCodeChallengeFromVerifier() {
          _generateCodeChallengeFromVerifier = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(v) {
            var hashed, base64encoded;
            return _regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return _sha(v);

                  case 2:
                    hashed = _context7.sent;
                    base64encoded = _base64urlencode(hashed);
                    return _context7.abrupt("return", base64encoded);

                  case 5:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));
          return _generateCodeChallengeFromVerifier.apply(this, arguments);
        }

        var _getAuthCode = function _getAuthCode() {
          var urlParams = typeof window !== "undefined" ? new URLSearchParams(window.location.search) : null;
          return urlParams === null || urlParams === void 0 ? void 0 : urlParams.get("code");
        };

        var _isUserAuthenticated = function _isUserAuthenticated() {
          var authInfo = _getFromLocalStorage("hfnAuthInfo");

          return authInfo === null || authInfo === void 0 ? void 0 : authInfo.access_token;
        };

        var _generateCodeChallenge = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            var code_verifier;
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    code_verifier = generateCodeVerifier();
                    localStorage.setItem("code_verifier", code_verifier);
                    _context6.next = 4;
                    return generateCodeChallengeFromVerifier(code_verifier);

                  case 4:
                    return _context6.abrupt("return", _context6.sent);

                  case 5:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));

          return function _generateCodeChallenge() {
            return _ref.apply(this, arguments);
          };
        }();

        var _getRedirectUrl = function _getRedirectUrl() {
          var _window, _window$location;

          var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
          return typeof window !== "undefined" ? "".concat((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.origin).concat(path ? "/".concat(path) : "", "/oneauth/authorization") : "";
        };

        var _checkKeycloakTokenIsExpired = function _checkKeycloakTokenIsExpired(token) {
          try {
            var decodedToken = (0, jwt_decode__WEBPACK_IMPORTED_MODULE_0__.jwtDecode)(token);
            var loginDateTime = localStorage.getItem("loginDateTime") || null;

            if (loginDateTime) {
              var currentDateTime = new Date().getTime();
              var loggedInDateTime = new Date(loginDateTime).getTime();
              var activeDuration = currentDateTime - loggedInDateTime;
              var tokenValidity = Number(decodedToken.exp) - Number(decodedToken.iat);
              return activeDuration + 1000 > tokenValidity * 1000;
            }

            return true;
          } catch (_unused2) {
            return false;
          }
        };
        /***/

      },
      /* 3 */

      /***/
      function (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          InvalidTokenError: function InvalidTokenError() {
            return (
              /* binding */
              _InvalidTokenError
            );
          },

          /* harmony export */
          jwtDecode: function jwtDecode() {
            return (
              /* binding */
              _jwtDecode
            );
          }
          /* harmony export */

        });

        var _InvalidTokenError = /*#__PURE__*/function (_Error) {
          _inherits(_InvalidTokenError, _Error);

          var _super = _createSuper(_InvalidTokenError);

          function _InvalidTokenError() {
            _classCallCheck(this, _InvalidTokenError);

            return _super.apply(this, arguments);
          }

          return _InvalidTokenError;
        }( /*#__PURE__*/_wrapNativeSuper(Error));

        _InvalidTokenError.prototype.name = "InvalidTokenError";

        function b64DecodeUnicode(str) {
          return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
            var code = p.charCodeAt(0).toString(16).toUpperCase();

            if (code.length < 2) {
              code = "0" + code;
            }

            return "%" + code;
          }));
        }

        function base64UrlDecode(str) {
          var output = str.replace(/-/g, "+").replace(/_/g, "/");

          switch (output.length % 4) {
            case 0:
              break;

            case 2:
              output += "==";
              break;

            case 3:
              output += "=";
              break;

            default:
              throw new Error("base64 string is not of the correct length");
          }

          try {
            return b64DecodeUnicode(output);
          } catch (err) {
            return atob(output);
          }
        }

        function _jwtDecode(token, options) {
          if (typeof token !== "string") {
            throw new _InvalidTokenError("Invalid token specified: must be a string");
          }

          options || (options = {});
          var pos = options.header === true ? 0 : 1;
          var part = token.split(".")[pos];

          if (typeof part !== "string") {
            throw new _InvalidTokenError("Invalid token specified: missing part #".concat(pos + 1));
          }

          var decoded;

          try {
            decoded = base64UrlDecode(part);
          } catch (e) {
            throw new _InvalidTokenError("Invalid token specified: invalid base64 for part #".concat(pos + 1, " (").concat(e.message, ")"));
          }

          try {
            return JSON.parse(decoded);
          } catch (e) {
            throw new _InvalidTokenError("Invalid token specified: invalid json for part #".concat(pos + 1, " (").concat(e.message, ")"));
          }
        }
        /***/

      },
      /* 4 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          html: function html() {
            return (
              /* binding */
              _html
            );
          }
          /* harmony export */

        });

        var _html = "\n        <div class=\"auth-overlay\">\n          <div class=\"auth-container\">\n            <div class=\"loader-logo\">\n              <img\n                src=\"https://cdn-prod.heartfulness.org/images/logo_heartfulness.svg\"\n                alt=\"heartfulness\"\n                width=\"200\"\n              />\n            </div>\n            <div id=\"loader\" class=\"spacing\">\n              <div class=\"loader-container\">\n                <div class=\"loader-icon\"></div>\n              </div>\n              <p id=\"loaderText\" class=\"spacing\"></p>\n            </div>\n            <p class=\"error-msg spacing error-block\"></p>\n            <div class=\"spacing\">\n              <button id=\"cancel-btn\" class=\"custom-button cancelBtn\">Cancel</button>\n              <button id=\"retry-btn\" class=\"custom-button error-block\">\n                Retry Login\n              </button>\n            </div>\n          </div>\n        </div>\n";
        /***/
      },
      /* 5 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */

        });
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11);
        /* harmony import */


        var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _node_modules_css_loader_dist_cjs_js_loader_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12);

        var options = {};
        options.styleTagTransform = _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default();
        options.setAttributes = _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default();
        options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
        options.domAPI = _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default();
        options.insertStyleElement = _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default();

        var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_loader_css__WEBPACK_IMPORTED_MODULE_6__["default"], options);
        /* harmony default export */


        var __WEBPACK_DEFAULT_EXPORT__ = _node_modules_css_loader_dist_cjs_js_loader_css__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_loader_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_loader_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined;
        /***/

      },
      /* 6 */

      /***/
      function (module) {
        var stylesInDOM = [];

        function getIndexByIdentifier(identifier) {
          var result = -1;

          for (var i = 0; i < stylesInDOM.length; i++) {
            if (stylesInDOM[i].identifier === identifier) {
              result = i;
              break;
            }
          }

          return result;
        }

        function modulesToDom(list, options) {
          var idCountMap = {};
          var identifiers = [];

          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = options.base ? item[0] + options.base : item[0];
            var count = idCountMap[id] || 0;
            var identifier = "".concat(id, " ").concat(count);
            idCountMap[id] = count + 1;
            var indexByIdentifier = getIndexByIdentifier(identifier);
            var obj = {
              css: item[1],
              media: item[2],
              sourceMap: item[3],
              supports: item[4],
              layer: item[5]
            };

            if (indexByIdentifier !== -1) {
              stylesInDOM[indexByIdentifier].references++;
              stylesInDOM[indexByIdentifier].updater(obj);
            } else {
              var updater = addElementStyle(obj, options);
              options.byIndex = i;
              stylesInDOM.splice(i, 0, {
                identifier: identifier,
                updater: updater,
                references: 1
              });
            }

            identifiers.push(identifier);
          }

          return identifiers;
        }

        function addElementStyle(obj, options) {
          var api = options.domAPI(options);
          api.update(obj);

          var updater = function updater(newObj) {
            if (newObj) {
              if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
                return;
              }

              api.update(obj = newObj);
            } else {
              api.remove();
            }
          };

          return updater;
        }

        module.exports = function (list, options) {
          options = options || {};
          list = list || [];
          var lastIdentifiers = modulesToDom(list, options);
          return function update(newList) {
            newList = newList || [];

            for (var i = 0; i < lastIdentifiers.length; i++) {
              var identifier = lastIdentifiers[i];
              var index = getIndexByIdentifier(identifier);
              stylesInDOM[index].references--;
            }

            var newLastIdentifiers = modulesToDom(newList, options);

            for (var _i = 0; _i < lastIdentifiers.length; _i++) {
              var _identifier = lastIdentifiers[_i];

              var _index = getIndexByIdentifier(_identifier);

              if (stylesInDOM[_index].references === 0) {
                stylesInDOM[_index].updater();

                stylesInDOM.splice(_index, 1);
              }
            }

            lastIdentifiers = newLastIdentifiers;
          };
        };
        /***/

      },
      /* 7 */

      /***/
      function (module) {
        /* istanbul ignore next  */
        function apply(styleElement, options, obj) {
          var css = "";

          if (obj.supports) {
            css += "@supports (".concat(obj.supports, ") {");
          }

          if (obj.media) {
            css += "@media ".concat(obj.media, " {");
          }

          var needLayer = typeof obj.layer !== "undefined";

          if (needLayer) {
            css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
          }

          css += obj.css;

          if (needLayer) {
            css += "}";
          }

          if (obj.media) {
            css += "}";
          }

          if (obj.supports) {
            css += "}";
          }

          var sourceMap = obj.sourceMap;

          if (sourceMap && typeof btoa !== "undefined") {
            css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
          } // For old IE

          /* istanbul ignore if  */


          options.styleTagTransform(css, styleElement, options.options);
        }

        function removeStyleElement(styleElement) {
          // istanbul ignore if
          if (styleElement.parentNode === null) {
            return false;
          }

          styleElement.parentNode.removeChild(styleElement);
        }
        /* istanbul ignore next  */


        function domAPI(options) {
          if (typeof document === "undefined") {
            return {
              update: function update() {},
              remove: function remove() {}
            };
          }

          var styleElement = options.insertStyleElement(options);
          return {
            update: function update(obj) {
              apply(styleElement, options, obj);
            },
            remove: function remove() {
              removeStyleElement(styleElement);
            }
          };
        }

        module.exports = domAPI;
        /***/
      },
      /* 8 */

      /***/
      function (module) {
        var memo = {};
        /* istanbul ignore next  */

        function getTarget(target) {
          if (typeof memo[target] === "undefined") {
            var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

            if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
              try {
                // This will throw an exception if access to iframe is blocked
                // due to cross-origin restrictions
                styleTarget = styleTarget.contentDocument.head;
              } catch (e) {
                // istanbul ignore next
                styleTarget = null;
              }
            }

            memo[target] = styleTarget;
          }

          return memo[target];
        }
        /* istanbul ignore next  */


        function insertBySelector(insert, style) {
          var target = getTarget(insert);

          if (!target) {
            throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          }

          target.appendChild(style);
        }

        module.exports = insertBySelector;
        /***/
      },
      /* 9 */

      /***/
      function (module, __unused_webpack_exports, __webpack_require__) {
        /* istanbul ignore next  */
        function setAttributesWithoutAttributes(styleElement) {
          var nonce = true ? __webpack_require__.nc : 0;

          if (nonce) {
            styleElement.setAttribute("nonce", nonce);
          }
        }

        module.exports = setAttributesWithoutAttributes;
        /***/
      },
      /* 10 */

      /***/
      function (module) {
        /* istanbul ignore next  */
        function insertStyleElement(options) {
          var element = document.createElement("style");
          options.setAttributes(element, options.attributes);
          options.insert(element, options.options);
          return element;
        }

        module.exports = insertStyleElement;
        /***/
      },
      /* 11 */

      /***/
      function (module) {
        /* istanbul ignore next  */
        function styleTagTransform(css, styleElement) {
          if (styleElement.styleSheet) {
            styleElement.styleSheet.cssText = css;
          } else {
            while (styleElement.firstChild) {
              styleElement.removeChild(styleElement.firstChild);
            }

            styleElement.appendChild(document.createTextNode(css));
          }
        }

        module.exports = styleTagTransform;
        /***/
      },
      /* 12 */

      /***/
      function (module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */

        });
        /* harmony import */


        var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
        /* harmony import */


        var _node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
        /* harmony import */


        var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__); // Imports


        var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()(_node_modules_css_loader_dist_runtime_noSourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()); // Module


        ___CSS_LOADER_EXPORT___.push([module.id, "\n.auth-overlay {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  z-index: 1000;\n  top: 0;\n  left: 0;\n  background: linear-gradient(135deg, #ffffff, #e0e0e0);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: black;\n}\n\n.loader-logo {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-top: 2%;\n}\n\n.loader-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.loader-icon{\n  width: 50px;\n  padding: 8px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: #005ca3;\n  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;\n  -webkit-mask: var(--_m);\n  mask: var(--_m);\n  -webkit-mask-composite: source-out;\n  mask-composite: subtract;\n  animation: spin 1s infinite linear;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n#loaderText {\n  text-align: center;\n}\n\n.custom-button {\n  background-color: #4CAF50; \n  border: none; \n  color: white;\n  padding: 12px 24px; \n  text-align: center; \n  text-decoration: none; \n  display: inline-block; \n  font-size: 14px; \n  margin: 4px 2px; \n  cursor: pointer; \n  border-radius: 8px; \n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.custom-button:hover {\n  background-color: #45a049;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2); \n}\n\n.cancelBtn{\n  background-color: black !important; \n}\n.cancelBtn:hover{\n  background-color: rgb(35, 35, 35) !important; \n}\n\n#cancel-btn{\n display: none; \n}\n\n.error-msg {\n  background-color: #fce7e8; \n  color: #721c24;\n  border: 2px solid #f5c6cb; \n  padding: 12px 20px; \n  border-radius: 8px; \n  margin: 10px 0;  \n  font-size: 16px;   display: inline-block;\n  width: 95%; \n  box-sizing: border-box; \n}\n\n.spacing{\n  margin-top: 1.5rem;\n}\n\n.error-block{\n  display: none;\n}\n\n.auth-container{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  padding: 20px 15px;\n  margin: 16px;\n  width: 40%;\n  transition: box-shadow 0.3s ease-in-out;\n}\n\n@media (max-width:568px){\n  .auth-container{\n    width: 70%;\n  }\n}", ""]); // Exports

        /* harmony default export */


        var __WEBPACK_DEFAULT_EXPORT__ = ___CSS_LOADER_EXPORT___;
        /***/
      },
      /* 13 */

      /***/
      function (module) {
        module.exports = function (i) {
          return i[1];
        };
        /***/

      },
      /* 14 */

      /***/
      function (module) {
        /*
          MIT License http://www.opensource.org/licenses/mit-license.php
          Author Tobias Koppers @sokra
        */
        module.exports = function (cssWithMappingToString) {
          var list = []; // return the list of modules as css string

          list.toString = function toString() {
            return this.map(function (item) {
              var content = "";
              var needLayer = typeof item[5] !== "undefined";

              if (item[4]) {
                content += "@supports (".concat(item[4], ") {");
              }

              if (item[2]) {
                content += "@media ".concat(item[2], " {");
              }

              if (needLayer) {
                content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
              }

              content += cssWithMappingToString(item);

              if (needLayer) {
                content += "}";
              }

              if (item[2]) {
                content += "}";
              }

              if (item[4]) {
                content += "}";
              }

              return content;
            }).join("");
          }; // import a list of modules into the list


          list.i = function i(modules, media, dedupe, supports, layer) {
            if (typeof modules === "string") {
              modules = [[null, modules, undefined]];
            }

            var alreadyImportedModules = {};

            if (dedupe) {
              for (var k = 0; k < this.length; k++) {
                var id = this[k][0];

                if (id != null) {
                  alreadyImportedModules[id] = true;
                }
              }
            }

            for (var _k = 0; _k < modules.length; _k++) {
              var item = [].concat(modules[_k]);

              if (dedupe && alreadyImportedModules[item[0]]) {
                continue;
              }

              if (typeof layer !== "undefined") {
                if (typeof item[5] === "undefined") {
                  item[5] = layer;
                } else {
                  item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
                  item[5] = layer;
                }
              }

              if (media) {
                if (!item[2]) {
                  item[2] = media;
                } else {
                  item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
                  item[2] = media;
                }
              }

              if (supports) {
                if (!item[4]) {
                  item[4] = "".concat(supports);
                } else {
                  item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
                  item[4] = supports;
                }
              }

              list.push(item);
            }
          };

          return list;
        };
        /***/

      },
      /* 15 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */

        });
        /* harmony import */


        var _native_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
        /* harmony import */


        var _rng_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17);
        /* harmony import */


        var _stringify_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);

        function v4(options, buf, offset) {
          if (_native_js__WEBPACK_IMPORTED_MODULE_0__["default"].randomUUID && !buf && !options) {
            return _native_js__WEBPACK_IMPORTED_MODULE_0__["default"].randomUUID();
          }

          options = options || {};

          var rnds = options.random || (options.rng || _rng_js__WEBPACK_IMPORTED_MODULE_1__["default"])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`


          rnds[6] = rnds[6] & 0x0f | 0x40;
          rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

          if (buf) {
            offset = offset || 0;

            for (var i = 0; i < 16; ++i) {
              buf[offset + i] = rnds[i];
            }

            return buf;
          }

          return (0, _stringify_js__WEBPACK_IMPORTED_MODULE_2__.unsafeStringify)(rnds);
        }
        /* harmony default export */


        var __WEBPACK_DEFAULT_EXPORT__ = v4;
        /***/
      },
      /* 16 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */

        });

        var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
        /* harmony default export */

        var __WEBPACK_DEFAULT_EXPORT__ = {
          randomUUID: randomUUID
        };
        /***/
      },
      /* 17 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return (
              /* binding */
              rng
            );
          }
          /* harmony export */

        }); // Unique ID creation requires a high quality random # generator. In the browser we therefore
        // require the crypto API and do not support built-in fallback to lower quality random number
        // generators (like Math.random()).


        var getRandomValues;
        var rnds8 = new Uint8Array(16);

        function rng() {
          // lazy load so that environments that need to polyfill have a chance to do so
          if (!getRandomValues) {
            // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
            getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

            if (!getRandomValues) {
              throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
            }
          }

          return getRandomValues(rnds8);
        }
        /***/

      },
      /* 18 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          },

          /* harmony export */
          unsafeStringify: function unsafeStringify() {
            return (
              /* binding */
              _unsafeStringify
            );
          }
          /* harmony export */

        });
        /* harmony import */


        var _validate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
        /**
         * Convert array of 16 byte values to UUID string format of the form:
         * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
         */


        var byteToHex = [];

        for (var i = 0; i < 256; ++i) {
          byteToHex.push((i + 0x100).toString(16).slice(1));
        }

        function _unsafeStringify(arr) {
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          // Note: Be careful editing this code!  It's been tuned for performance
          // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
          //
          // Note to future-self: No, you can't remove the `toLowerCase()` call.
          // REF: https://github.com/uuidjs/uuid/pull/677#issuecomment-1757351351
          return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
        }

        function stringify(arr) {
          var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

          var uuid = _unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
          // of the following:
          // - One or more input array values don't map to a hex octet (leading to
          // "undefined" in the uuid)
          // - Invalid input values for the RFC `version` or `variant` fields


          if (!(0, _validate_js__WEBPACK_IMPORTED_MODULE_0__["default"])(uuid)) {
            throw TypeError('Stringified UUID is invalid');
          }

          return uuid;
        }
        /* harmony default export */


        var __WEBPACK_DEFAULT_EXPORT__ = stringify;
        /***/
      },
      /* 19 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */

        });
        /* harmony import */


        var _regex_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20);

        function validate(uuid) {
          return typeof uuid === 'string' && _regex_js__WEBPACK_IMPORTED_MODULE_0__["default"].test(uuid);
        }
        /* harmony default export */


        var __WEBPACK_DEFAULT_EXPORT__ = validate;
        /***/
      },
      /* 20 */

      /***/
      function (__unused_webpack_module, __webpack_exports__, __webpack_require__) {
        __webpack_require__.r(__webpack_exports__);
        /* harmony export */


        __webpack_require__.d(__webpack_exports__, {
          /* harmony export */
          "default": function _default() {
            return __WEBPACK_DEFAULT_EXPORT__;
          }
          /* harmony export */

        });
        /* harmony default export */


        var __WEBPACK_DEFAULT_EXPORT__ = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;
        /***/
      }
      /******/
      ];
      /************************************************************************/

      /******/
      // The module cache

      /******/

      var __webpack_module_cache__ = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/
        // Check if module is in cache

        /******/
        var cachedModule = __webpack_module_cache__[moduleId];
        /******/

        if (cachedModule !== undefined) {
          /******/
          return cachedModule.exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = __webpack_module_cache__[moduleId] = {
          /******/
          id: moduleId,

          /******/
          // no module.loaded needed

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
        /******/

        /******/
        // Return the exports of the module

        /******/


        return module.exports;
        /******/
      }
      /******/

      /************************************************************************/

      /******/

      /* webpack/runtime/compat get default export */

      /******/


      (function () {
        /******/
        // getDefaultExport function for compatibility with non-harmony modules

        /******/
        __webpack_require__.n = function (module) {
          /******/
          var getter = module && module.__esModule ?
          /******/
          function () {
            return module['default'];
          } :
          /******/
          function () {
            return module;
          };
          /******/

          __webpack_require__.d(getter, {
            a: getter
          });
          /******/


          return getter;
          /******/
        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/define property getters */

      /******/


      (function () {
        /******/
        // define getter functions for harmony exports

        /******/
        __webpack_require__.d = function (exports, definition) {
          /******/
          for (var key in definition) {
            /******/
            if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
              /******/
              Object.defineProperty(exports, key, {
                enumerable: true,
                get: definition[key]
              });
              /******/
            }
            /******/

          }
          /******/

        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/hasOwnProperty shorthand */

      /******/


      (function () {
        /******/
        __webpack_require__.o = function (obj, prop) {
          return Object.prototype.hasOwnProperty.call(obj, prop);
        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/make namespace object */

      /******/


      (function () {
        /******/
        // define __esModule on exports

        /******/
        __webpack_require__.r = function (exports) {
          /******/
          if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
            /******/
            Object.defineProperty(exports, Symbol.toStringTag, {
              value: 'Module'
            });
            /******/
          }
          /******/


          Object.defineProperty(exports, '__esModule', {
            value: true
          });
          /******/
        };
        /******/

      })();
      /******/

      /******/

      /* webpack/runtime/nonce */

      /******/


      (function () {
        /******/
        __webpack_require__.nc = undefined;
        /******/
      })();
      /******/

      /************************************************************************/


      var __webpack_exports__ = {};

      __webpack_require__.r(__webpack_exports__);
      /* harmony export */


      __webpack_require__.d(__webpack_exports__, {
        /* harmony export */
        getMeProfile: function getMeProfile() {
          return (
            /* binding */
            _getMeProfile
          );
        },

        /* harmony export */
        getRefreshToken: function getRefreshToken() {
          return (
            /* binding */
            _getRefreshToken
          );
        },

        /* harmony export */
        getSRCMProfile: function getSRCMProfile() {
          return (
            /* binding */
            _getSRCMProfile
          );
        },

        /* harmony export */
        userLogout: function userLogout() {
          return (
            /* binding */
            _userLogout2
          );
        }
        /* harmony export */

      });
      /* harmony import */


      var _js_auth_authentication_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
      /* harmony import */


      var uuid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
      /* harmony import */


      var _js_html_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
      /* harmony import */


      var _js_utils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
      /* harmony import */


      var _styles_loader_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);

      var authentionObj = new _js_auth_authentication_js__WEBPACK_IMPORTED_MODULE_0__.Authentication();

      var _userLogout2 = function _userLogout2(config) {
        var subPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        return authentionObj.userLogout(config, subPath);
      };

      var _getRefreshToken = function _getRefreshToken(config) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return authentionObj.getActiveToken(config, force);
      };

      var _getMeProfile = function _getMeProfile(config) {
        return authentionObj.getMySRCMProfie(config);
      };

      var _getSRCMProfile = function _getSRCMProfile(config) {
        return authentionObj.getMeSRCMProfie(config);
      };

      var OneAuth = /*#__PURE__*/function (_HTMLElement) {
        _inherits(OneAuth, _HTMLElement);

        var _super2 = _createSuper(OneAuth);

        function OneAuth() {
          var _this;

          _classCallCheck(this, OneAuth);

          _this = _super2.call(this);
          _this.$authObj = new _js_auth_authentication_js__WEBPACK_IMPORTED_MODULE_0__.Authentication();

          _this.loginCallback = function () {};

          _this.handleProfileAuthentication = _this.handleProfileAuthentication.bind(_assertThisInitialized(_this));
          _this.triggerAuth = _this.triggerAuth.bind(_assertThisInitialized(_this));
          _this.handleVisibilityChange = _this.handleVisibilityChange.bind(_assertThisInitialized(_this));
          _this.handlePageShow = _this.handlePageShow.bind(_assertThisInitialized(_this));
          return _this;
        }

        _createClass(OneAuth, [{
          key: "handleGlobalLogout",
          value: function handleGlobalLogout() {
            this.dispatchEvent(new CustomEvent("userLoggedOut", {
              detail: {
                loggedOut: true
              }
            }));
          }
        }, {
          key: "connectedCallback",
          value: function connectedCallback() {
            var _this$getAuthAttribut = this.getAuthAttributes(),
                authType = _this$getAuthAttribut.authType;

            if (authType !== "on-demand") {
              this.initializeAuthFlow();
            }

            document.addEventListener("visibilitychange", this.handleVisibilityChange);
            window.addEventListener("pageshow", this.handlePageShow);
          }
        }, {
          key: "disconnectedCallback",
          value: function disconnectedCallback() {
            document.removeEventListener("visibilitychange", this.handleVisibilityChange);
            window.removeEventListener("pageshow", this.handlePageShow);
          }
        }, {
          key: "handlePageShow",
          value: function handlePageShow(event) {
            if (event.persisted) {
              window.location.reload();
            }
          }
        }, {
          key: "handleVisibilityChange",
          value: function () {
            var _handleVisibilityChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
              var _this$getAuthAttribut2, client_id, realm, authUrl, _response$data, response;

              return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                while (1) {
                  switch (_context8.prev = _context8.next) {
                    case 0:
                      _this$getAuthAttribut2 = this.getAuthAttributes(), client_id = _this$getAuthAttribut2.client_Id, realm = _this$getAuthAttribut2.realm, authUrl = _this$getAuthAttribut2.baseurl;

                      if (!(document.visibilityState === "visible")) {
                        _context8.next = 8;
                        break;
                      }

                      if (!(0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.isUserAuthenticated)()) {
                        _context8.next = 7;
                        break;
                      }

                      _context8.next = 5;
                      return _getRefreshToken({
                        client_id: client_id,
                        realm: realm,
                        authUrl: authUrl
                      }, true);

                    case 5:
                      response = _context8.sent;

                      if (!(response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.access_token)) {
                        this.handleGlobalLogout();
                      }

                    case 7:
                      if (!(0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.isUserAuthenticated)()) {
                        this.handleGlobalLogout();
                      }

                    case 8:
                    case "end":
                      return _context8.stop();
                  }
                }
              }, _callee8, this);
            }));

            function handleVisibilityChange() {
              return _handleVisibilityChange.apply(this, arguments);
            }

            return handleVisibilityChange;
          }()
        }, {
          key: "renderComponent",
          value: function renderComponent() {
            this.innerHTML = _js_html_js__WEBPACK_IMPORTED_MODULE_1__.html;
            this.cacheDOMElements();
          }
        }, {
          key: "cacheDOMElements",
          value: function cacheDOMElements() {
            this.$loader = this.querySelector("#loader");
            this.$loaderText = this.querySelector("#loaderText");
            this.$comp = this.querySelector(".auth-overlay");
            this.$cancelBtn = this.querySelector("#cancel-btn");
          }
        }, {
          key: "initializeAuthFlow",
          value: function initializeAuthFlow() {
            this.checkAuthAndRedirect();
          }
        }, {
          key: "checkAuthAndRedirect",
          value: function () {
            var _checkAuthAndRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
              var code;
              return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                while (1) {
                  switch (_context9.prev = _context9.next) {
                    case 0:
                      code = (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.getAuthCode)();

                      if (!(0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.isUserAuthenticated)() && code) {
                        this.renderComponent();
                        this.handleAuthCallback(code);
                      } else if (!(0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.isUserAuthenticated)() && !code) {
                        this.renderComponent();
                        this.triggerLogin();
                      }

                    case 2:
                    case "end":
                      return _context9.stop();
                  }
                }
              }, _callee9, this);
            }));

            function checkAuthAndRedirect() {
              return _checkAuthAndRedirect.apply(this, arguments);
            }

            return checkAuthAndRedirect;
          }()
        }, {
          key: "setLoader",
          value: function setLoader(isLoading) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            this.$loader.style.display = isLoading ? "block" : "none";
            if (text) this.$loaderText.innerHTML = text;
          }
        }, {
          key: "cancel",
          value: function cancel() {
            localStorage.removeItem("hfnAuthInfo");
            this.hideComponent();
            var path = localStorage.getItem("LandingPage");
            window.location.href = "".concat(window.location.origin).concat(path);
          }
        }, {
          key: "configureCancelButton",
          value: function configureCancelButton(displayCancelBtn) {
            if (this.$cancelBtn) {
              this.$cancelBtn.style.display = displayCancelBtn === "true" ? "inline-block" : "none";

              if (displayCancelBtn === "true") {
                this.$cancelBtn.onclick = this.cancel.bind(this);
              }
            }
          }
        }, {
          key: "hideComponent",
          value: function hideComponent() {
            this.$comp.style.display = "none";
          }
        }, {
          key: "getAuthAttributes",
          value: function getAuthAttributes() {
            var config = JSON.parse(this.getAttribute("config"));
            return {
              baseurl: config === null || config === void 0 ? void 0 : config.authUrl,
              client_Id: config === null || config === void 0 ? void 0 : config.client_id,
              realm: config === null || config === void 0 ? void 0 : config.realm,
              redirect_uri: (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.getRedirectUrl)(this.getAttribute("subPath")),
              authType: this.getAttribute("authType"),
              displayCancelBtn: this.getAttribute("showCancel"),
              additional_param: this.getAttribute("additionalParam")
            };
          }
        }, {
          key: "getAuthPayload",
          value: function getAuthPayload(code, client_Id, redirect_uri) {
            var codeVerifier = localStorage.getItem("code_verifier");
            var state = localStorage.getItem("state");
            var formData = new URLSearchParams();
            formData.append("client_id", client_Id);
            formData.append("grant_type", "authorization_code");
            formData.append("code", code);
            formData.append("redirect_uri", redirect_uri);
            formData.append("code_verifier", codeVerifier);
            formData.append("scope", "openid");
            formData.append("state", state);
            return formData;
          }
        }, {
          key: "handleAuthCallback",
          value: function () {
            var _handleAuthCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(code) {
              var _this$getAuthAttribut3, client_Id, realm, redirect_uri, baseurl, loginData;

              return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                while (1) {
                  switch (_context10.prev = _context10.next) {
                    case 0:
                      _this$getAuthAttribut3 = this.getAuthAttributes(), client_Id = _this$getAuthAttribut3.client_Id, realm = _this$getAuthAttribut3.realm, redirect_uri = _this$getAuthAttribut3.redirect_uri, baseurl = _this$getAuthAttribut3.baseurl;
                      this.setLoader(true, "Fetching Profile Information...");
                      _context10.prev = 2;
                      _context10.next = 5;
                      return this.$authObj.getLoginData(baseurl, this.getAuthPayload(code, client_Id, redirect_uri), realm);

                    case 5:
                      loginData = _context10.sent;

                      if (!(loginData !== null && loginData !== void 0 && loginData.error)) {
                        localStorage.setItem("loginDateTime", new Date());
                        (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.storeInLocalStorage)("hfnAuthInfo", loginData === null || loginData === void 0 ? void 0 : loginData.data);
                        this.loginCallback(loginData);
                      } else {
                        this.displayError((loginData === null || loginData === void 0 ? void 0 : loginData.message) || "Something went wrong.");
                      }

                      _context10.next = 12;
                      break;

                    case 9:
                      _context10.prev = 9;
                      _context10.t0 = _context10["catch"](2);
                      this.displayError("Something went wrong.");

                    case 12:
                    case "end":
                      return _context10.stop();
                  }
                }
              }, _callee10, this, [[2, 9]]);
            }));

            function handleAuthCallback(_x10) {
              return _handleAuthCallback.apply(this, arguments);
            }

            return handleAuthCallback;
          }()
        }, {
          key: "triggerLogin",
          value: function () {
            var _triggerLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
              var _this$getAuthAttribut4, baseurl, client_Id, realm, redirect_uri, additional_param, state, codeChallenge;

              return _regeneratorRuntime.wrap(function _callee11$(_context11) {
                while (1) {
                  switch (_context11.prev = _context11.next) {
                    case 0:
                      _this$getAuthAttribut4 = this.getAuthAttributes(), baseurl = _this$getAuthAttribut4.baseurl, client_Id = _this$getAuthAttribut4.client_Id, realm = _this$getAuthAttribut4.realm, redirect_uri = _this$getAuthAttribut4.redirect_uri, additional_param = _this$getAuthAttribut4.additional_param;

                      if ((0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.isUserAuthenticated)()) {
                        _context11.next = 9;
                        break;
                      }

                      this.setLoader(true, "Redirecting to HFN Oneauth...");
                      state = (0, uuid__WEBPACK_IMPORTED_MODULE_4__["default"])();
                      localStorage.setItem("state", state);
                      _context11.next = 7;
                      return (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.generateCodeChallenge)();

                    case 7:
                      codeChallenge = _context11.sent;

                      if (baseurl && client_Id && realm && redirect_uri && state && codeChallenge) {
                        this.redirectToLogin(baseurl, client_Id, realm, redirect_uri, state, codeChallenge, additional_param);
                      }

                    case 9:
                    case "end":
                      return _context11.stop();
                  }
                }
              }, _callee11, this);
            }));

            function triggerLogin() {
              return _triggerLogin.apply(this, arguments);
            }

            return triggerLogin;
          }()
        }, {
          key: "redirectToLogin",
          value: function redirectToLogin(baseurl, client_Id, realm, redirectUri, state, codeChallenge, moreParam) {
            var _this2 = this;

            setTimeout(function () {
              if (typeof window !== "undefined" && !_this2.cancelBtnClicked) {
                var redirectUrl = "".concat(baseurl, "/realms/").concat(realm, "/protocol/openid-connect/auth?client_id=").concat(client_Id, "&response_type=code&redirect_uri=").concat(redirectUri, "&scope=openid&state=").concat(state, "&code_challenge_method=S256&code_challenge=").concat(codeChallenge);
                if (moreParam && moreParam !== null) redirectUrl = "".concat(redirectUrl).concat(moreParam);
                window.location.href = redirectUrl;
              }
            }, 2000);
          }
        }, {
          key: "displayError",
          value: function displayError(error) {
            this.setLoader(false);

            var _this$getAuthAttribut5 = this.getAuthAttributes(),
                displayCancelBtn = _this$getAuthAttribut5.displayCancelBtn;

            this.configureCancelButton(displayCancelBtn);
            var retry = (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.getDomElementById)("retry-btn");
            retry.onclick = this.retryLogin.bind(this);
            (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.showErrorMsg)(".error-msg", error);
            (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.displayErrorBlock)();
          }
        }, {
          key: "handleProfileAuthentication",
          value: function handleProfileAuthentication(status) {
            if (!status) {
              this.displayError("Error Fetching Profile Information. Please retry login.");
            } else {
              this.hideComponent();
            }
          }
        }, {
          key: "triggerAuth",
          value: function triggerAuth() {
            this.initializeAuthFlow();
          }
        }, {
          key: "retryLogin",
          value: function () {
            var _retryLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
              return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                while (1) {
                  switch (_context12.prev = _context12.next) {
                    case 0:
                      (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.HideBlock)(".error-block");
                      (0, _js_utils_js__WEBPACK_IMPORTED_MODULE_2__.clearLsAuthInfo)();
                      this.triggerLogin();

                    case 3:
                    case "end":
                      return _context12.stop();
                  }
                }
              }, _callee12, this);
            }));

            function retryLogin() {
              return _retryLogin.apply(this, arguments);
            }

            return retryLogin;
          }()
        }]);

        return OneAuth;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      if (!customElements.get("hfn-oneauth")) customElements.define("hfn-oneauth", OneAuth);
      /******/

      return __webpack_exports__;
      /******/
    }()
  );
});